import { render, staticRenderFns } from "./labelSheetStatusBadge.vue?vue&type=template&id=bd6d46ca&"
import script from "./labelSheetStatusBadge.vue?vue&type=script&lang=js&"
export * from "./labelSheetStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports